import React from 'react';
import PropTypes from 'prop-types';
import { InputField } from '@zola/zola-ui';

const NewTableFieldSet = ({ data, onRemove, onChange, setCount }) => {
  const rgx = new RegExp(/^[0-9\b]+$/);
  const handleTableChange = (e) => {
    const newVal = rgx.test(e.target.value) ? e.target.value : '';
    onChange({ ...data, num_tables: newVal });
  }
  const handleSeatChange = (e) => {
    const newVal = rgx.test(e.target.value) ? e.target.value : '';
    onChange({ ...data, num_seats: newVal });
  }

  return (
    <div className="table-set">
        <InputField
          placeholder="10"
          label="Number of Tables"
          onChange={handleTableChange}
          type="text"
          value={data.num_tables}
        />
        <InputField
          placeholder="8"
          label="Number of Seats"
          onChange={handleSeatChange}
          type="text"
          value={data.num_seats}
        />
      {setCount > 1 && (
      <div className="onboarding-trash" role="button">
        <i className="zolaicon zolaicon-trash" onClick={onRemove} />
      </div>
    )}
    </div>
  );
};

NewTableFieldSet.propTypes = {
  data: PropTypes.shape({
    num_seats: PropTypes.string,
    num_tables: PropTypes.string,
  }),
  setCount: PropTypes.number,
  onRemove: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default NewTableFieldSet;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/ChartCreator/NewTableFieldset/NewTableFieldset.jsx